import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Imgs } from "../../img/Imgs/Imgs";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const Partner = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <section className="partner">
      <div className="partner__container container">
        <div className="partner__main">
          <div className="partner__imgs">
            <img src={Imgs.partnerback} alt="partner" />
            <img src={Imgs.partnerfront} alt="partner" />
          </div>
        </div>
        <div className="partner__context">
          <h2>{translations[selectedLanguages].partner.title}</h2>
          <p>{translations[selectedLanguages].partner.firstDescription}</p>
          <p>{translations[selectedLanguages].partner.secondDescription}</p>
          <Link to="/contact">
            {translations[selectedLanguages].partner.button}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Partner;
